export function initLoadMoreRelated() {
  (function ($) {
    const $relatedGrid = $("#related-articles-grid");
    const $loadMoreBtn = $("#load-more-related");

    if (!$relatedGrid.length || !$loadMoreBtn.length) return;

    let currentPage = 1; // Start at 1, since page 1 is what is initially visible

    // Get Data Attributes
    const categoryId = parseInt($relatedGrid.data("category-id"));
    const currentPostId = parseInt($relatedGrid.data("post-id"));

    // Store original button HTML to restore icon after loading
    const originalBtnHtml = $loadMoreBtn.html();

    $loadMoreBtn.on("click", function (e) {
      e.preventDefault();

      const nextPage = currentPage + 1;

      $.ajax({
        url: duconData.ajaxurl, // Ensure variable case matches functions.php localization
        type: "POST",
        dataType: "json",
        data: {
          action: "load_more_related_articles",
          nonce: duconData.nonce,
          page: nextPage,
          category_id: categoryId,
          current_post: currentPostId,
        },
        beforeSend: function () {
          $loadMoreBtn
            .prop("disabled", true)
            .css("opacity", "0.7")
            .html('<i class="fas fa-spinner fa-spin"></i> Loading...');
        },
        success: function (response) {
          if (response.success && response.data.content) {
            // Append content with a simple fade-in effect
            const $content = $(response.data.content).hide();
            $relatedGrid.append($content);
            $content.fadeIn(400);

            // Update State
            currentPage = nextPage;

            // Restore Button
            $loadMoreBtn
              .prop("disabled", false)
              .css("opacity", "1")
              .html(originalBtnHtml);

            // LOGIC FIX: Check against 'max_pages' sent from PHP
            if (currentPage >= response.data.max_pages) {
              $loadMoreBtn.fadeOut(300, function () {
                $(this).parent().append(
                  // Append to wrapper, not button itself
                  '<p class="text-center text-gray-600 mt-6">No more related posts.</p>',
                );
                $(this).remove(); // Remove the button entirely
              });
            }
          } else {
            // Handle empty success state
            handleNoMorePosts();
          }
        },
        error: function (xhr, status, error) {
          console.error("AJAX Error:", error);
          $loadMoreBtn
            .prop("disabled", false)
            .css("opacity", "1")
            .text("Try Again");
        },
      });

      function handleNoMorePosts() {
        $loadMoreBtn.fadeOut(300, function () {
          $(this).remove();
        });
      }
    });
  })(jQuery);
}
